<span class="labelText width100procent">
    {{value$ | async}}
</span>